import HttpResponse from "../../../../utils/http/http.response";

export enum CandidaturePreviewCandidateEntryType {
  CREATE_SOLVED_ORDER = "CREATE_SOLVED_ORDER",
  CREATE_PLAN_ENTRY = "CREATE_PLAN_ENTRY",
}

export enum CandidaturePreviewCandidateRideType {
  STRICT = "STRICT",
}

export enum CandidaturePreviewCandidateTimingPolicy {
  REQUESTED = "REQUESTED",
  OPTIMIZED = "OPTIMIZED",
}

export enum CandidaturePreviewNotAcceptableResponseErrorType {
  NO_TAXI_DRIVER_ASSOCIATION = "NO_TAXI_DRIVER_ASSOCIATION",
  NO_VALID_TAXI_DRIVER_CONTRACT = "NO_VALID_TAXI_DRIVER_CONTRACT",
  NO_VALID_TAXI_RAILY_CONTRACT = "NO_VALID_TAXI_RAILY_CONTRACT",
  NO_VALID_CARGO_RAILY_CONTRACT = "NO_VALID_CARGO_RAILY_CONTRACT",
  TARGET_PLAN_ENTRY_NOT_FOUND = "TARGET_PLAN_ENTRY_NOT_FOUND",
  CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME = "CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME",
  CANDIDATE_DOES_NOT_FIT = "CANDIDATE_DOES_NOT_FIT",
  TOO_MANY_CHECKOUT_EVENTS = "TOO_MANY_CHECKOUT_EVENTS",
  CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION = "CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION",
  DELETE_SOLVED_ORDER_TARGET_NOT_FOUND = "DELETE_SOLVED_ORDER_TARGET_NOT_FOUND",
  TARGET_ORDER_CANCELLED = "TARGET_ORDER_CANCELLED",
  PLAN_ENTRY_CANDIDATE_COLLISION = "PLAN_ENTRY_CANDIDATE_COLLISION",
  FORBIDDEN_TAXI = "FORBIDDEN_TAXI",
  FORBIDDEN_PLAN_ENTRY = "FORBIDDEN_PLAN_ENTRY",
}

export type CandidaturePreviewNotAcceptableResponseNoTaxiDriverAssociationError =
  {
    errorType: CandidaturePreviewNotAcceptableResponseErrorType.NO_TAXI_DRIVER_ASSOCIATION;
    driverId: string;
    taxiId: string;
  };

export type CandidaturePreviewNotAcceptableResponseNoValidTaxiDriverContractError =
  {
    errorType: CandidaturePreviewNotAcceptableResponseErrorType.NO_VALID_TAXI_DRIVER_CONTRACT;
    driverId: string;
    taxiId: string;
  };

export type CandidaturePreviewNotAcceptableResponseNoValidTaxiRailyContractError =
  {
    errorType: CandidaturePreviewNotAcceptableResponseErrorType.NO_VALID_TAXI_RAILY_CONTRACT;
  };

export type CandidaturePreviewNotAcceptableResponseNoValidCargoRailyContractError =
  {
    errorType: CandidaturePreviewNotAcceptableResponseErrorType.NO_VALID_CARGO_RAILY_CONTRACT;
    driverId: string;
    taxiId: string;
  };

type CandidaturePreviewNotAcceptableResponseTargetPlanEntryNotFoundError = {
  errorType: CandidaturePreviewNotAcceptableResponseErrorType.TARGET_PLAN_ENTRY_NOT_FOUND;
  candidateEntryId: string;
  targetPlanEntryId: string;
};

type CandidaturePreviewNotAcceptableResponseTooManyCheckoutEventsError = {
  errorType: CandidaturePreviewNotAcceptableResponseErrorType.TOO_MANY_CHECKOUT_EVENTS;
};

type CandidaturePreviewNotAcceptableResponseCandidateFitsWithNotEnoughTimeError =
  {
    errorType: CandidaturePreviewNotAcceptableResponseErrorType.CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME;
    candidatureId: string;
    candidatureEntryId: string;
    collidingSolvedOrderId: string;
    candidatureSolvedOrderId: string;
  };

type CandidaturePreviewNotAcceptableResponseCandidateDoesNotFitError = {
  errorType: CandidaturePreviewNotAcceptableResponseErrorType.CANDIDATE_DOES_NOT_FIT;
  candidatureId: string;
  candidatureEntryId: string;
  candidatureSolvedOrderId: string;
};

type CandidaturePreviewNotAcceptableResponseCandidatePlanEntryCollidesError = {
  errorType: CandidaturePreviewNotAcceptableResponseErrorType.CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION;
  candidatureId: string;
  candidatureEntryId: string;
  candidaturePlanEntryId: string;
};

type CandidaturePreviewNotAcceptableResponseDeleteSolvedOrderTargetNotFoundError =
  {
    errorType: CandidaturePreviewNotAcceptableResponseErrorType.DELETE_SOLVED_ORDER_TARGET_NOT_FOUND;
    candidatureId: string;
    candidateEntryId: string;
    targetSolvedOrderId: string;
  };

type CandidaturePreviewNotAcceptableResponseTargetTransportingOrderCancelledError =
  {
    errorType: CandidaturePreviewNotAcceptableResponseErrorType.TARGET_ORDER_CANCELLED;
    candidatureId: string;
    candidateEntryId: string;
    targetSolvedOrderId: string;
  };

type CandidaturePreviewNotAcceptableResponsePlanEntryCandidateCollisionError = {
  errorType: CandidaturePreviewNotAcceptableResponseErrorType.PLAN_ENTRY_CANDIDATE_COLLISION;
  candidatureId: string;
  candidateEntryId: string;
};

type CandidaturePreviewNotAcceptableResponseForbiddenTaxiError = {
  errorType: CandidaturePreviewNotAcceptableResponseErrorType.FORBIDDEN_TAXI;
  providedTaxiId: string;
};

type CandidaturePreviewNotAcceptableResponseForbiddenPlanEntryError = {
  errorType: CandidaturePreviewNotAcceptableResponseErrorType.FORBIDDEN_PLAN_ENTRY;
  providedPlanEntryId: string;
};

export type CandidaturePreviewNotAcceptableResponseError =
  | CandidaturePreviewNotAcceptableResponseNoTaxiDriverAssociationError
  | CandidaturePreviewNotAcceptableResponseNoValidTaxiDriverContractError
  | CandidaturePreviewNotAcceptableResponseNoValidTaxiRailyContractError
  | CandidaturePreviewNotAcceptableResponseNoValidCargoRailyContractError
  | CandidaturePreviewNotAcceptableResponseDeleteSolvedOrderTargetNotFoundError
  | CandidaturePreviewNotAcceptableResponseTargetPlanEntryNotFoundError
  | CandidaturePreviewNotAcceptableResponseTooManyCheckoutEventsError
  | CandidaturePreviewNotAcceptableResponseCandidateFitsWithNotEnoughTimeError
  | CandidaturePreviewNotAcceptableResponseCandidateDoesNotFitError
  | CandidaturePreviewNotAcceptableResponseCandidatePlanEntryCollidesError
  | CandidaturePreviewNotAcceptableResponseTargetTransportingOrderCancelledError
  | CandidaturePreviewNotAcceptableResponsePlanEntryCandidateCollisionError
  | CandidaturePreviewNotAcceptableResponseForbiddenTaxiError
  | CandidaturePreviewNotAcceptableResponseForbiddenPlanEntryError;

export type CandidaturePreviewResponseItemDraftCandidatingPlanEntryOrderPointsNodeData =
  {
    address: string;
    date: Date;
  };

export type CandidaturePreviewResponseItemDraftCandidatingPlanEntryOrderPoint =
  {
    humanId: number;
    waypoints: CandidaturePreviewResponseItemDraftCandidatingPlanEntryOrderPointsNodeData[];
  };

export type CandidaturePreviewResponseItemDraftCandidatingPlanEntryStartData = {
  address: string;
  date: Date;
};

export type CandidaturePreviewResponseItemDraftCandidatingPlanEntryEndData = {
  address: string;
  date: Date;
};

export type CandidaturePreviewResponseItemDraftCandidatingPlanEntry = {
  id: string;
  humanId: number;
  start: CandidaturePreviewResponseItemDraftCandidatingPlanEntryStartData;
  end: CandidaturePreviewResponseItemDraftCandidatingPlanEntryEndData;
  orders: CandidaturePreviewResponseItemDraftCandidatingPlanEntryOrderPoint[];
};

export type CandidaturePreviewResponseItemCandidatingPlanEntryOrderPointsNodeData =
  {
    address: string;
    date: Date;
  };

export type CandidaturePreviewResponseItemCandidatingPlanEntryOrderPoint = {
  humanId: number;
  waypoints: CandidaturePreviewResponseItemCandidatingPlanEntryOrderPointsNodeData[];
};

export type CandidaturePreviewResponseItemCandidatingPlanEntryStartData = {
  address: string;
  date: Date;
};

export type CandidaturePreviewResponseItemCandidatingPlanEntryEndData = {
  address: string;
  date: Date;
};

export type CandidaturePreviewResponseItemCandidatingPlanEntry = {
  id: string;
  humanId: number;
  start: CandidaturePreviewResponseItemCandidatingPlanEntryStartData;
  end: CandidaturePreviewResponseItemCandidatingPlanEntryEndData;
  orders: CandidaturePreviewResponseItemCandidatingPlanEntryOrderPoint[];
};

export type CandidaturePreviewResponseItemPlanEntryOrderPointsNodeData = {
  address: string;
  date: Date;
};

export type CandidaturePreviewResponseItemPlanEntryOrderPoint = {
  humanId: number;
  waypoints: CandidaturePreviewResponseItemPlanEntryOrderPointsNodeData[];
};

export type CandidaturePreviewResponseItemPlanEntryStartData = {
  address: string;
  date: Date;
};

export type CandidaturePreviewResponseItemPlanEntryEndData = {
  address: string;
  date: Date;
};

export type CandidaturePreviewResponseItemPlanEntry = {
  id: string;
  humanId: number;
  start: CandidaturePreviewResponseItemPlanEntryStartData;
  end: CandidaturePreviewResponseItemPlanEntryEndData;
  orders: CandidaturePreviewResponseItemPlanEntryOrderPoint[];
};

export type CandidaturePreviewResponseItemCreateSolvedOrderCandidating = {
  candidateEntryType: CandidaturePreviewCandidateEntryType.CREATE_SOLVED_ORDER;
  planEntryId: string | null;
  createPlanEntryId: string | null;
  transportingOrderId: string;
  id: string;
  candidatingSolve: string;
};

export type CandidaturePreviewResponseItemCreatePlanEntryCandidating = {
  candidateEntryType: CandidaturePreviewCandidateEntryType.CREATE_PLAN_ENTRY;
  createPlanEntryId: string | null;
  transportingOrderId: string;
  id: string;
  givenPlanEntryId: string;
  candidatingSolve: string;
  taxiCorporationId: string;
};

export type CandidaturePreviewResponseItemCandidatingRequest =
  | CandidaturePreviewResponseItemCreateSolvedOrderCandidating
  | CandidaturePreviewResponseItemCreatePlanEntryCandidating;

export type CandidaturePreviewResponseItem = {
  planEntries: CandidaturePreviewResponseItemPlanEntry[];
  candidatureEntries: CandidaturePreviewResponseItemCandidatingPlanEntry[];
  draftCandidatureEntries: CandidaturePreviewResponseItemDraftCandidatingPlanEntry[];
  candidatingRequest: CandidaturePreviewResponseItemCandidatingRequest;
};

export type CandidaturePreviewSuccessResponse =
  HttpResponse<CandidaturePreviewResponseItem>;

export type CandidaturePreviewNotAcceptableResponse =
  HttpResponse<CandidaturePreviewNotAcceptableResponseError>;

type CandidaturePreviewResponse =
  | CandidaturePreviewSuccessResponse
  | CandidaturePreviewNotAcceptableResponse;

export default CandidaturePreviewResponse;
